import React from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Avatar, Chip, Divider, Stack, Typography } from "@mui/material";
import { Menu } from "components/popups";

import { NewsHeader, NewsTag } from "./News";

interface Props {
  header: NewsHeader;
  tag?: NewsTag;
}

export const NewsHeaderComponent: React.FC<Props> = ({ header, tag }) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "1px solid #dbe8f5",
        pb: "10px",
        gap: "10px"
      }}
    >
      <Avatar variant="rounded" src={header.avatarUrl} sx={{ width: 40, height: 40, borderRadius: "6px" }} />
      <Stack sx={{ flexGrow: 1 }}>
        <Stack>
          <Stack sx={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#071f35", lineHeight: "24px" }}>
              {header.title}
            </Typography>
            <Stack direction="row" gap="10px" alignItems="center">
              {tag && (
                <Chip
                  label={tag.label}
                  size="small"
                  sx={{
                    // height: "24px",
                    fontSize: "12px",
                    fontWeight: 400,
                    bgcolor: tag.color || "#f6f8fc",
                    color: "#071f35"
                  }}
                />
              )}
              <Menu
                icon={<MoreVertIcon sx={{ fontSize: "16px", color: "#071f35" }} />}
                iconButtonProps={{
                  sx: {
                    width: "24px",
                    height: "24px",
                    padding: "4px"
                  }
                }}
                options={[]}
              />
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="row" gap="5px" alignItems="center">
          {header.source && (
            <>
              <Typography sx={{ fontSize: "14px", color: "#496682", lineHeight: "16px" }}>{header.source}</Typography>
              <Divider orientation="vertical" flexItem sx={{ height: "16px", borderColor: "#dbe8f5" }} />
            </>
          )}
          {header.date && (
            <>
              <Typography sx={{ fontSize: "14px", color: "#496682", lineHeight: "16px" }}>{header.date}</Typography>
              <Divider orientation="vertical" flexItem sx={{ height: "16px", borderColor: "#dbe8f5" }} />
            </>
          )}
          {header.category && (
            <>
              <Typography sx={{ fontSize: "14px", color: "#496682", lineHeight: "16px" }}>{header.category}</Typography>
              <Divider orientation="vertical" flexItem sx={{ height: "16px", borderColor: "#dbe8f5" }} />
            </>
          )}
          <Typography sx={{ fontSize: "14px", color: "#071f35", lineHeight: "16px" }}>{header.timeAgo}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
